import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { TicketOrdersEntityGrid } from '../features/tickets-order-entity-grid';

export const TicketOrdersPage = observer(() => {
  return (
    <AppPage perm="*" noWrapper>
      <TicketOrdersEntityGrid />
    </AppPage>
  );
});
